export const MSG_TYPE = {
  EXAMPLE: Symbol(),
  LOGIN_USERNAME: Symbol(),
  START_GET_MENUS: Symbol(),
  IS_COLLAPSED: Symbol(),
  // 水价归属
  CLOSE_WATER_CATEGORIES_FORM: Symbol(),
  GET_WATER_CATEGORIES_TREE: Symbol(),
  SELECT_WATER_CATEGORIES: Symbol(),
  CREATE_WATER_CATEGORIES: Symbol(),
  GET_WATER_CATEGORIES: Symbol(),
  CREATE_ROOT_WATER_CATEGORIES: Symbol(),
  NOTICE_CANCEL_CREATE_ROOT_WATER_CATEGORIES: Symbol(),
  CLOSE_CREATE_WATER_CATEGORIES: Symbol(),
  EDIT_WATER_CATEGORIES: Symbol(),
  CHECK_WATER_CATEGORIES: Symbol(),
  UPDATE_WATER_CATEGORIES_STATUS: Symbol(),
  REFRESH_WATER_CATEGORIES_TREE: Symbol(),
  HAS_LOGIN: Symbol(),
  // 刷新标记
  REFRESH_CURRENT_COMP: Symbol(),
  // 批量修改中的信息传递
  TRANSFORM_MESSAGES: Symbol(),

  // 水价调整
  CREATE_NEW_WATER_PRICE_ITEM: Symbol(),
  EDIT_WATER_PRICE_ITEM: Symbol(),
  PATCH_WATER_PRICE_TABLE: Symbol(),
  START_SAVE_WATER_PRICE_CACHE_DATA: Symbol(),
  START_SAVE_WATER_PRICE_DATA: Symbol(),
  SEND_TRANSFORM_WATER_PRICE_DATA: Symbol(),
  SEND_TRANSFORM_WATER_PRICE_DATA_SAVE: Symbol(),
  SELECT_WATER_PRICE_ITEM: Symbol(),
  CHECK_WATER_PRICE_HISTORY: Symbol(),
  SEND_WATER_PRICE_HISTORY_PAGES: Symbol(),

  // 词语信息
  GET_WORDS_INFORMATION_TREE: Symbol(),

  // 客户信息
  SHOW_CUSTOMER_DETAIL: Symbol(),
  JUMP_TO_CHARGE: Symbol(),
  // 基础设置图片、文字改变
  REFRESH_BROWSER_TITLE: Symbol(),
  REFRESH_BROWSER_PIC: Symbol(),
  REFRESH_LOGIN_TITLE: Symbol(),
  REFRESH_LOGIN_PIC: Symbol(),
  REFRESH_MENU_IMG_BIG: Symbol(),
  REFRESH_MENU_IMG_SMALL: Symbol(),
  REFRESH_SHOW_COPYRIGHT: Symbol(),

  // Websocket连接
  WEBSOCKET_CONNECT_ERROR: Symbol(),
  // 未销调整弹出流程模块标记
  NORECONCILE_WORKFLOOR_OPEN: Symbol(),
  // 入库明细
  WAREHOUSINGDETAIL: Symbol(),
  OUT_OF_STOCKDETAIL: Symbol(),
  CHECK_METER_DETAIL: Symbol(),
  // 新闻管理
  LIST_ARTICLE: Symbol(),
  JUMP_TO_ARTICLE: Symbol(),
  NEW_ARTICLES: Symbol(),

  // 导出及signalR推送
  START_EXPORT_FILE: Symbol(),
  EXPORT_FILE_ERROR: Symbol(),

  // 处理客户信息跳转到指定行
  HANDLE_CUST_INFO_SCROLL: Symbol(),

  // 通知页面脱敏状态变化
  CHANGE_DATA_MASKING: Symbol(),

  // 设备信息
  SHOW_VALVE_DETAIL: Symbol(),
};

